import { render, staticRenderFns } from "./TheLibraryDocuments.vue?vue&type=template&id=13e22584&"
import script from "./TheLibraryDocuments.vue?vue&type=script&lang=js&"
export * from "./TheLibraryDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TheLibraryDocuments.vue?vue&type=style&index=0&id=13e22584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports